import { useState } from 'react';
import { useJournal } from '../api/hooks';
import { Chargement, Erreur, Vide } from '../composants/Etats';
import { Pagination } from '../composants/Pagination';
import { dateHeure } from '../format';

export function PageJournal() {
  const [page, setPage] = useState(1);
  const [resultat, setResultat] = useState<string>('');
  const { data, isLoading, error, refetch } = useJournal(page, resultat || undefined);

  return (
    <section className="page" id="contenu">
      <div className="phead">
        <h1>Journal</h1>
        <p>
          Les envois automatiques et les passages du robot de suivi, avec leur résultat. C&apos;est ici
          qu&apos;on voit qu&apos;un mail n&apos;est pas parti — sinon l&apos;échec reste invisible et personne
          ne sait qu&apos;un client n&apos;a pas été prévenu.
        </p>
      </div>

      <div className="filters">
        <div className="seg" role="group" aria-label="Filtrer par résultat">
          {[['', 'Tout'], ['echec', 'Échecs'], ['ok', 'Succès']].map(([cle, libelle]) => (
            <button
              key={cle || 'tout'} type="button" aria-pressed={resultat === cle}
              onClick={() => { setResultat(cle!); setPage(1); }}
            >
              {libelle}
            </button>
          ))}
        </div>
      </div>

      {error && <Erreur erreur={error} onReessayer={() => void refetch()} />}
      {isLoading && !data && <Chargement />}

      {data && data.elements.length === 0 && !error && (
        <Vide
          titre={resultat === 'echec' ? 'Aucun échec' : "Rien pour l'instant"}
          aide={
            resultat === 'echec'
              ? 'Tous les envois automatiques sont passés.'
              : "Le journal se remplit dès qu'un tracking est saisi ou qu'une relance est enregistrée."
          }
        />
      )}

      {data && data.elements.length > 0 && (
        <>
          <div className="tablewrap">
            <table>
              <thead>
                <tr>
                  <th scope="col">Horodatage</th>
                  <th scope="col">Commande</th>
                  <th scope="col">Événement</th>
                  <th scope="col">Détail</th>
                  <th scope="col">Auteur</th>
                  <th scope="col">Résultat</th>
                </tr>
              </thead>
              <tbody>
                {data.elements.map((e) => (
                  <tr key={e.id} className={e.resultat === 'echec' ? 's3' : 's0'}>
                    <td className="lead mono">{dateHeure(e.at)}</td>
                    <td className="mono">{e.ref ?? '—'}</td>
                    <td>
                      {e.evenement}
                      {e.simule && <div className="sub">simulé — intégration en mode local</div>}
                    </td>
                    <td className="sub" style={{ fontSize: 12.5 }}>
                      {e.detail}
                      {e.erreur && <div className="err" style={{ marginTop: 4 }}>{e.erreur}</div>}
                    </td>
                    <td className="sub" style={{ fontSize: 12.5 }}>{e.auteur}</td>
                    <td>
                      <span className={`tag ${e.resultat === 'ok' ? 'pine' : 'brick'}`}>
                        {e.resultat === 'ok' ? 'succès' : 'échec'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <Pagination
            page={data.page} pages={data.pages} total={data.total} taille={data.taille} onPage={setPage}
          />
        </>
      )}
    </section>
  );
}
